package es.subastia.utils

import androidx.compose.runtime.Composable
import kotlin.time.Clock
import kotlin.time.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.toLocalDateTime
import kotlinx.datetime.todayIn
import org.jetbrains.compose.resources.stringResource
import subastia.composeapp.generated.resources.Res
import subastia.composeapp.generated.resources.month_april
import subastia.composeapp.generated.resources.month_august
import subastia.composeapp.generated.resources.month_december
import subastia.composeapp.generated.resources.month_february
import subastia.composeapp.generated.resources.month_january
import subastia.composeapp.generated.resources.month_july
import subastia.composeapp.generated.resources.month_june
import subastia.composeapp.generated.resources.month_march
import subastia.composeapp.generated.resources.month_may
import subastia.composeapp.generated.resources.month_november
import subastia.composeapp.generated.resources.month_october
import subastia.composeapp.generated.resources.month_september

@Composable
fun String.toUserFriendlyDate(): String {
    val instant = Instant.parse(this)
    val localDateTime = instant.toLocalDateTime(TimeZone.currentSystemDefault())

    val monthName = stringResource(
        when (localDateTime.month.number) {
            1 -> Res.string.month_january
            2 -> Res.string.month_february
            3 -> Res.string.month_march
            4 -> Res.string.month_april
            5 -> Res.string.month_may
            6 -> Res.string.month_june
            7 -> Res.string.month_july
            8 -> Res.string.month_august
            9 -> Res.string.month_september
            10 -> Res.string.month_october
            11 -> Res.string.month_november
            12 -> Res.string.month_december
            else -> return this
        }
    )

    // Format: 15 Ene 2026, 18:00
    val minute = localDateTime.minute.toString().padStart(2, '0')
    val hour = localDateTime.hour.toString().padStart(2, '0')

    return "${localDateTime.day} $monthName ${localDateTime.year}, $hour:$minute"
}

fun String.isToday(): Boolean {
    val instant = Instant.parse(this)
    val zone = TimeZone.currentSystemDefault()
    val today = Clock.System.todayIn(zone)
    val date = instant.toLocalDateTime(zone).date
    return date == today
}
